
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active">
        <template #header>
          <h4 class="not-margin">
            Eliminar documento(s)
          </h4>
        </template>


        <div class="con-form">
            <div v-if="tipoAccion != 'alumno'">
                <p>El/Los documentos seleccionados son los siguientes:</p>
                <p class="mb-0" v-for="(doc, d) in docSelect" :key="d"><i><i class="fas fa-caret-right mr-1"></i>{{doc.original_filename}}</i></p>
                <p class="mt-2"><strong>¿Esta seguro de eliminarlos permanentemente?</strong></p>
            </div>
            <div v-else>
                <p>Los documentos de los alumnos seleccionados serán eliminados permanentemente.</p>
                <p class="mt-2"><strong>¿Esta seguro de eliminarlos?</strong></p>
            </div>
        </div>
        <template #footer>
          <vs-row>
              <vs-col sm="6" lg="6">
                <vs-button
                    danger
                    flat>
                    Cancelar
                </vs-button>
              </vs-col>
              <vs-col sm="6" lg="6">
                <vs-button
                    success
                    class="ml-auto"
                    @click="deletedMaterial()"
                >
                    Aceptar
                </vs-button>
              </vs-col>
          </vs-row>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import evaluaciones from '../../../../api/requests/docente/evaluaciones';
  export default {
    props:[
        'value',
        'docSelect',
        'tipoAccion'
    ],
    data:() => ({
        active: false,
    }),
    methods: {
      deletedMaterial(id){
        const vue = this
        const loading = this.$vs.loading()
        let documentos = []
        if(this.tipoAccion == 'alumno'){
          this.docSelect.forEach(element => {
            const documentosArray = Object.values(element.documentos)
            if(documentosArray.length){
              documentos.push(...documentosArray)
            }
          });
        }
        let valor = 0
        for(var i = 0; i < documentos.length; i++ ) {
            valor += 1
          try{
            const response = evaluaciones.deletedMaterial(documentos[i].id)
              if(valor === documentos.length){
                  loading.close()
                  this.$emit('refreshTable')
                  this.$vs.notification({
                      progress: 'auto',
                      color: 'success',
                      title: 'Operación éxitosa',
                      text: 'Se ha eliminado correctamente el material.'
                  })
                this.active = false
              }
          }catch(error){
            this.$emit('refreshTable')
            console.log(error)
            if(valor === documentos.length){
                loading.close()
                vue.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Hubo un problema',
                })
            }
            loading.close()
          }
        }
      }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
  }
  </script>

<style scoped>
  .vs-select-content{
    max-width: 100% !important;
}
</style>